














































































































import { Component, Vue } from "vue-property-decorator";
import { alarm, app, sensor } from "@/store";
import AttachedDeviceModel from "@/models/AttachedDeviceModel";
import {
    computed,
    defineComponent,
    onMounted,
    ref
} from "@vue/composition-api";
import { ILocationFromParticle } from "../models/AlarmStatus";
import 'core-js';
import useTemperature from "@/store/useTemperature";
import TemperatureViewModel from "@/models/TemperatureViewModel";
import { VPagination } from "vuetify/lib/components";
import { enrollState } from '@/store';
import { enrollUi } from '@/store/enrollUi';

export default defineComponent({
    name: "Home",
    components: {
        Battery: () =>
            import(/* webpackChunkName: "components" */ "./components/BatteryView.vue"),
        AlarmButton: () =>
            import(
    /* webpackChunkName: "components" */ "./components/ArmDisarmButton.vue"
            ),
        SilenceButton: () =>
            import(
                /* webpackChunkName: "components" */ "./components/SilenceButton.vue"
            ),
        SensorItem: () =>
            import(
    /* webpackChunkName: "components" */ "./components/Sensors/DefaultSensorListItem.vue"
            ),
        ShorePowerItem: () =>
            import(
    /* webpackChunkName: "components" */ "./components/Sensors/ShorePowerListItem.vue"
            ),
        SmartPlugItem: () =>
            import(
    /* webpackChunkName: "components" */ "./components/Sensors/SmartPlugListItem.vue"
            ),
        DoorSensorItem: () =>
            import(
    /* webpackChunkName: "components" */ "./components/Sensors/DoorSensorListItem.vue"
            ),
        HatchSensorItem: () =>
            import(
    /* webpackChunkName: "components" */ "./components/Sensors/HatchSensorListItem.vue"
            ),
        VoltageGraph: () =>
            import(
    /* webpackChunkName: "components" */ "./components/Dialogs/VoltageDialog.vue"
            )
    },
    setup(_, { root }) {
        const showGrafDialog1 = ref<boolean>(false);
        const showGrafDialog2 = ref<boolean>(false);
        const connectSensor = ref<AttachedDeviceModel>();
        const gpsLocationAge = ref<string>("");
        let lastGpsTime: Date | null = null;
        let lastHeardIntervalId: any | null = null;
        const { get } = useTemperature();
        const smallVoltageLimit = 0.5;
        const lowVoltageLimit12V = 11.8;
        const highVoltageLimit12V = 14.8;
        const lowVoltageLimit24V = 23.6;
        const highVoltageLimit24V = 29.5;
        const chargingThreshold = 19; // Anything above this might be 24V battery

        const armed = computed(() => { return alarm.armed; });

        function detectBatteryType(voltage: number): "12V" | "24V" {
            return voltage < chargingThreshold ? "12V" : "24V";
        }

        function getBatteryType(voltage: number): string {
            if (voltage === -1) return "Unknown";
            return detectBatteryType(voltage);
        }

        function isVoltageWarning(voltage: number): boolean {
            if (voltage === -1) return false;
            const type = detectBatteryType(voltage);

            return type === "12V"
                ? voltage < lowVoltageLimit12V || voltage > highVoltageLimit12V
                : voltage < lowVoltageLimit24V || voltage > highVoltageLimit24V;
        }

        function getVoltage(value: string | undefined): number {
            if (value === "NotPresent") return -1;
            const parsed = parseFloat(value !== undefined && value !== null ? value : "-1");
            return parsed < smallVoltageLimit ? -1 : parsed;
        }

        const power1 = computed(() => {
            return alarm.alarmStatus &&
                alarm.alarmStatus.VSupplies &&
                alarm.alarmStatus.VSupplies[0] &&
                getVoltage(alarm.alarmStatus.VSupplies[0].V1);
        });

        const power2 = computed(() => {
            return alarm.alarmStatus &&
                alarm.alarmStatus.VSupplies &&
                alarm.alarmStatus.VSupplies[0] &&
                getVoltage(alarm.alarmStatus.VSupplies[0].V2);
        });

        const voltageWarning1 = computed(() => isVoltageWarning(power1.value));
        const voltageWarning2 = computed(() => isVoltageWarning(power2.value));

        const hatchsensorModel = computed<AttachedDeviceModel>(() => {
            return getItem(1);
        });
        const shorePowerModel = computed<AttachedDeviceModel | null>(() => {
            if (!Array.isArray(sensor.devices)) {
                return null;
            }
            const found = sensor.devices.find((device) => device.attachedDeviceTypeId === 2);
            return found ? found : null;
        });
        const smartplugModel = computed<AttachedDeviceModel>(() => {
            return getItem(3);
        });
        const doorsensorModel = computed<AttachedDeviceModel>(() => {
            return getItem(10);
        });
        const temperatureModel = ref<TemperatureViewModel | null>(null);
        get().then((model: TemperatureViewModel) => {
            temperatureModel.value = model;
        });

        const getItem = (type: number): AttachedDeviceModel => {
            let model: AttachedDeviceModel = new AttachedDeviceModel();
            if (Array.isArray(sensor.devices) && sensor.devices.length > 0) {
                const foundModel = sensor.devices.find((value: AttachedDeviceModel) => {
                    return value.attachedDeviceTypeId === type;
                });
                if (foundModel != null) {
                    return foundModel;
                }
            }
            model.attachedDeviceTypeId = type;
            return model;
        };

        const doorPaired = computed(() => {
            const model = doorsensorModel.value;
            return model.attachedDeviceId != null && model.attachedDeviceId !== "";
        });

        const hatchPaired = computed(() => {
            const model = hatchsensorModel.value;
            return model.attachedDeviceId != null && model.attachedDeviceId !== "";
        });

        const doorResponsive = computed(() => {
            return doorPaired.value && doorsensorModel.value.age == 0;
        });

        const hatchResponsive = computed(() => {
            return hatchPaired.value && hatchsensorModel.value.age == 0;
        });

        const latitude = computed<string>(() => {
            return alarm.lat ? alarm.lat.toString() : "-.--";
        });

        const longitude = computed<string>(() => {
            return alarm.lng ? alarm.lng.toString() : "-.--";
        });

        const accuracy = computed<string>(() => {
            const location = alarm.lastKnownLocation && alarm.lastKnownLocation.location;
            const accuracyValue = location && location.horizontal_accuracy;

            if (accuracyValue === undefined || accuracyValue === null) {
                return "-.--";
            }
            console.log("accuracyValue", accuracyValue.toFixed(0) + " m");
            return accuracyValue.toFixed(0) + " m";
        });

        const latLetter = computed<string>(() => parseFloat(latitude.value) >= 0 ? "N" : "S");

        const lngLetter = computed<string>(() => parseFloat(longitude.value) >= 0 ? "E" : "W");

        const statusLoading = computed<boolean>(() => { return alarm.syncStatus; });

        const goToMob = () => {
            if (alarm.userLocReady) {
                root.$router.push({ name: "mob" });
            } else {
                root.$router.push({ name: "geo-permission", params: { destination: "mob" } });
            }
        };

        const generateTimeString = function (days, hours, minutes, seconds) {
            var timestring = "";

            if (days > 0) timestring += days + "d ";
            if (hours > 0 || timestring !== "") timestring += hours + "h ";
            if (minutes > 0 || timestring !== "") timestring += minutes + "m ";
            timestring += seconds + "s";

            return timestring.trim() + " ago";
        };

        const isSilenceSirenAvailable = computed(() => alarm.isSilenceSirenAvailable);

        function initTimer(alarmInstance) {
            if (
                alarmInstance &&
                alarmInstance.lastKnownLocation &&
                alarmInstance.lastKnownLocation.location &&
                alarmInstance.lastKnownLocation.location.last_heard
            ) {
                const lastHeardStr = alarmInstance.lastKnownLocation.location.last_heard;
                const lastHeard = new Date(Date.parse(lastHeardStr)); // should be UTC
                const lastHeardTime = lastHeard.getTime();

                if (lastGpsTime && lastGpsTime.getTime() !== lastHeardTime) {
                    clearInterval(lastHeardIntervalId);
                    lastHeardIntervalId = null;
                }

                if (!lastHeardIntervalId) {
                    lastHeardIntervalId = setInterval(() => {
                        const now = new Date(); // current time
                        const nowUtc = now.getTime(); // in ms (UTC)
                        const distance = nowUtc - lastHeardTime;

                        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
                        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

                        //console.log("distance", distance, "nowUtc", new Date(nowUtc).toISOString(), "lastHeard", lastHeard.toISOString());

                        const timestring = generateTimeString(days, hours, minutes, seconds);
                        gpsLocationAge.value = timestring;
                    }, 1000);
                }

                lastGpsTime = lastHeard;
            } else {
                gpsLocationAge.value = "---";
                clearInterval(lastHeardIntervalId);
                lastHeardIntervalId = null;
                lastGpsTime = null;
            }
        }

        const panel = computed<number>(() => {
            if (app.getHomePanelOpen) {
                console.log("app.getHomePanelIndex", app.getHomePanelIndex);
                return app.getHomePanelIndex;
            } else {
                console.log("app.getHomePanelIndex", -1);
                return -1;
            }
        });

        const temperature = computed(() => {
            const model = temperatureModel.value;
            if (
                model &&
                model.cabinTemperature !== -273 &&
                (doorResponsive.value || hatchResponsive.value)
            ) {
                return model.cabinTemperature.toFixed(1);
            }
            return "-.--";
        });

        function openEnroll(payload: { typeId: number; img: string }) {
            enrollState.startEnrollment(payload.typeId);
            enrollUi.open(payload.img);
            console.log("Home openDialog", payload);
        }

        function unpair(payload: { deviceId: string }) {
            console.log("Home unpair", payload);
            sensor.UnpairDevice(payload.deviceId);
        }

        onMounted(() => {
            alarm.getGeoLocation();
            alarm.fetchSecondsSinceLastAlarm();
            alarm.$watch(function (m) { return m.lastKnownLocation; }, function () {
                initTimer(alarm);
            });
            sensor.GetData();

            // Print door model and hatch model to console
            console.log("doorsensorModel age", doorsensorModel.value.age);
            console.log("doorsensorModel isConnecting", doorsensorModel.value.isConnecting);
            console.log("hatchsensorModel age", hatchsensorModel.value.age);
            console.log("hatchsensorModel isConnecting", hatchsensorModel.value.isConnecting);
        });

        return {
            armed,
            power1,
            power2,
            shorePowerModel,
            smartplugModel,
            doorsensorModel,
            hatchsensorModel,
            latitude,
            longitude,
            statusLoading,
            showGrafDialog1,
            showGrafDialog2,
            connectSensor,
            gpsLocationAge,
            openEnroll,
            unpair,
            temperature,
            accuracy,
            latLetter,
            lngLetter,
            voltageWarning1,
            voltageWarning2,
            goToMob,
            getBatteryType,
            isSilenceSirenAvailable,
            panel
        };
    }
});

@Component({})
class Home extends Vue {
    public showGrafDialog1: boolean = false;
    public showGrafDialog2: boolean = false;
    public connectSensor: AttachedDeviceModel | null = null;
}
